import { SourceConfig } from '../types';
import cassandraLogo from '../../../../../images/logo-cassandra.svg';

const placeholderRecipe = `\
source:
    type: cassandra
    config:
        contact_point: ""
        port:
        username: ""
        password: ""

        # Profiling
        profiling:
            enabled: false
        stateful_ingestion:
            enabled: true
`;

export const CASSANDRA = 'cassandra';

const cassandraConfig: SourceConfig = {
    type: CASSANDRA,
    placeholderRecipe,
    displayName: 'Cassandra',
    docsUrl: 'https://datahubproject.io/docs/generated/ingestion/sources/cassandra/',
    logoUrl: cassandraLogo,
};

export default cassandraConfig;
